import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import {uid} from "react-uid";
import makeStyles from "@material-ui/core/styles/makeStyles";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {useEventListener} from "../../../../../Hooks/useEventListener";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import {useContextMenu} from "../../../../../Hooks";
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";

const useStyles = makeStyles(() => ({
    tableWrapper: {
        overflow: 'auto',
        padding: 5,
        width: '100%'
    },
    flexTable: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    }
}));
const TableFields = (props) => {
    const {
        elementPath, arrayPath, element, globalValues, screenName,
        goBack, openGroupMenu, addGroup, removeGroup, actionsContext, containerArrayPath
    } = props;
    const [isActive, setIsActive] = useState(false);
    const tableUID = uid(element);
    const table = document.getElementById(tableUID);
    const classes = useStyles();
    const pathToArray = containerArrayPath ? `${containerArrayPath}.${elementPath}` : elementPath;
    const arrayValues = findByString(globalValues.param[screenName], pathToArray) || [{}];
    const {onOpen, ContextMenu} = useContextMenu({
        addBefore: actionsContext.addRecord ? actionsContext.addRecord : addGroup,
        addAfter: actionsContext.addRecord ? actionsContext.addRecord : addGroup,
        remove: removeGroup,
        editRecord: actionsContext.editRecord,
        isEntityMixed: actionsContext.isEntityMixed
    });
    const onOpenContext = (e, currentPath, arrayPath, index, disabled = {}) => {
        onOpen(e, currentPath, arrayPath, index, disabled)
    };
    const eventListenerHandler = useCallback((e) => {
        if (!isActive) {
            let focusedCell = document.getElementById(e.target.id);
            function moveFocus(direction) {
                e.stopPropagation();
                e.preventDefault();
                let currentFocus = e.target.id.split('_');
                //currentFocus[0] - Y axis
                //currentFocus[1] - X axis
                let nextId = (d) => {
                    switch (d) {
                        case 'ArrowLeft':
                            currentFocus.splice(1, 1, +currentFocus[1] - 1);
                            return currentFocus.join('_');
                        case 'ArrowRight':
                            currentFocus.splice(1, 1, +currentFocus[1] + 1);
                            return currentFocus.join('_');
                        case 'ArrowUp':
                            currentFocus.splice(0, 1, +currentFocus[0] - 1);
                            return currentFocus.join('_');
                        case 'ArrowDown':
                            currentFocus.splice(0, 1, +currentFocus[0] + 1);
                            return currentFocus.join('_');
                        default:
                            return null
                    }
                };
                let nextCell = document.getElementById(nextId(direction));
                if (nextCell !== null) {
                    focusedCell.blur();
                    nextCell.focus();
                }
            }

            if (e.key === 'Escape') {
                goBack();
            }
            if (e.key === 'ArrowLeft' && focusedCell) {
                moveFocus(e.key)
            }
            if (e.key === 'ArrowRight' && focusedCell) {
                moveFocus(e.key)
            }
            if (e.key === 'ArrowUp' && focusedCell) {
                moveFocus(e.key)
            }
            if (e.key === 'ArrowDown' && focusedCell) {
                moveFocus(e.key)
            }
        }
    }, []);
    useEventListener('keydown', eventListenerHandler, table);

    return (
        <div className={classes.tableWrapper}>
            <div className={classes.flexTable} id={tableUID}>
                <TableHeader
                    globalValues={globalValues}
                    element={element}
                    screenName={screenName}
                />
                <TableBody
                    element={element}
                    arrayPath={arrayPath}
                    arrayValues={arrayValues}
                    elementPath={pathToArray}
                    globalValues={globalValues}
                    screenName={screenName}
                    setActiveCell={setIsActive}
                    openGroupMenu={openGroupMenu}
                    tableUID={tableUID}
                    onOpenContext={onOpenContext}
                    goBack={goBack}
                />
            </div>
            <ContextMenu/>
        </div>
    )
};

TableFields.propTypes = {
    element: PropTypes.object,
    elementPath: PropTypes.string,
    arrayPath: PropTypes.string,
    openGroupMenu: PropTypes.func,
    globalValues: PropTypes.object,
    goBack: PropTypes.func
};
export default JsonScreenHoc(TableFields);